import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'si',
    fullName: 'Sinhala',
    nativeName: 'සිංහල',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "පුදුම දෙයක් එනවා",
    landing_subtitle: "ArgVoid යනු යෙදුම් සහ ක්‍රීඩා සංවර්ධන චිත්‍රාගාරයකි. රැඳී සිටින්න, අලුත් දේවල් ඉක්මනින් පැමිණේ!",
    select_language: "භාෂාව තෝරන්න",
    search_placeholder: "භාෂා සොයන්න...",
    terms_title: "සේවා කොන්දේසි",
    policy_title: "රහස්යතා ප්රතිපත්තිය",
    cookies_title: "කුකී ප්‍රතිපත්තිය",
    terms_content: `
        <strong>1. කොන්දේසි </strong><br> පිළිගැනීම
        ArgVoid වෙත පිවිසීමෙන්, මෙම සේවා නියම පිළිගනු ලැබේ. මෙම නියමයන්ට එකඟ නොවන්නේ නම්, සේවාව භාවිතා නොකළ යුතුය.<br><br>

        <strong>2. වේදිකා භාවිතය</strong><br>
        ArgVoid සහ එහි යෙදුම් තොරතුරු සහ නිර්මාණාත්මක අරමුණු සඳහා "පවතින පරිදි" සපයනු ලැබේ. සේවාව භාවිතා කළ යුත්තේ නීත්‍යානුකූල අරමුණු සඳහා පමණි.<br><br>

        <strong>3. තහනම් හැසිරීම</strong><br>
        වෙබ් අඩවි අවදානම් සූරාකෑම, ස්පෑම් කිරීම හෝ යටිතල පහසුකම් වෙත අනවසරයෙන් ප්‍රවේශ වීමට උත්සාහ කිරීම සපුරා තහනම්ය.<br><br>

        <strong>4. වියාචනය</strong><br>
        දැනුම්දීමකින් තොරව ඕනෑම වේලාවක වේදිකාව සහ සේවාවන් වෙනස් කළ හැක. සේවාවේ පවතින කාලය හෝ ලබා ගැනීම සම්බන්ධයෙන් වගකීමක් ලබා නොදේ.
    `,
    policy_content: `
        <strong>1. තොරතුරු එකතුව</strong><br>
        වේදිකාවට මෙම අවස්ථාවේදී පරිශීලක සත්‍යාපනය හෝ ගිණුම් නිර්මාණය අවශ්‍ය නොවේ. අමුත්තන්ගෙන් පුද්ගලික හඳුනාගැනීමේ තොරතුරක් (නම් හෝ ඊමේල් ලිපින වැනි) සක්‍රියව රැස් නොකෙරේ.<br><br>

        <strong>2. භාවිත දත්ත</strong><br>
        අඩවි ගමනාගමනය තේරුම් ගැනීමට සහ යෙදුම් වැඩිදියුණු කිරීමට මූලික, නිර්නාමික විශ්ලේෂණ එකතු කළ හැක. මෙම දත්ත තනි පරිශීලක අනන්‍යතා වෙත සම්බන්ධ කර නැත.<br><br>

        <strong>3. තෙවන පාර්ශවීය සේවා</strong><br>
        තුන්වන පාර්ශ්ව සපයන්නන් සත්කාරක සහ විශ්ලේෂණ සේවා සඳහා භාවිතා කළ හැක. මෙම අදාළ සපයන්නන්ගේ රහස්‍යතා පරිචයන් ඔවුන්ගේ යටිතල පහසුකම් මත සැකසූ නිර්නාමික දත්ත පාලනය කරයි.<br><br>

        <strong>4. දත්ත ආරක්ෂාව</strong><br>
        වේදිකාව ආරක්ෂා කිරීම සඳහා සාධාරණ ආරක්ෂක පියවරයන් ක්රියාත්මක වේ. කෙසේ වෙතත්, අන්තර්ජාලය හරහා සම්ප්රේෂණය කිරීමේ කිසිදු ක්රමයක් සම්පූර්ණයෙන්ම ආරක්ෂිත නොවේ.<br><br>
    `,
    cookies_content: `
        <strong>1. කුකීස් සහ දේශීය ගබඩාව යනු කුමක්ද?</strong><br>
        කුකීස් සහ බ්‍රවුසර දේශීය ආචයනය යනු සංචාර හරහා වින්‍යාස කිරීමේ මනාපයන් මතක තබා ගැනීමට උපාංගයේ ගබඩා කර ඇති කුඩා දත්ත ගොනු වේ.<br><br>

        <strong>2. භාවිතයේ අරමුණ</strong><br>
        Browser LocalStorage වින්‍යාස සැකසුම් සුරැකීමට දැඩි ලෙස භාවිතා කරයි, එනම්:<br>
        - භාෂා මනාප <br>
        - පරිශීලක අතුරුමුහුණත් වින්‍යාසය (උදා., පිරිසැලසුම හෝ තේමා සැකසුම්)<br>
        - තාවකාලික යෙදුම් හැඹිලි<br><br>

        <strong>3. Tracking</strong><br> නැත
        කුකීස් සහ දේශීය ආචයනය වෙළඳ ප්‍රචාරණ හෝ තෙවන පාර්ශ්ව ලුහුබැඳීමේ අරමුණු සඳහා භාවිතා නොවේ. සියලුම ගබඩා කර ඇති දත්ත වේදිකාවේ මූලික ක්‍රියාකාරිත්වය සඳහා වේ.<br><br>

        <strong>4. Control</strong><br>
        බ්‍රවුසරයේ දත්ත ඕනෑම වේලාවක බ්‍රවුසර සිටුවම් හරහා හිස් කළ හැකි අතර, එමඟින් ඕනෑම දේශීය වින්‍යාසයක් යළි සකසනු ඇත.
    `,
    cookie_consent_text: "ඔබේ සැසිය සක්‍රියව තබා ගැනීම, ඔබේ භාෂා මනාපය සුරැකීම, සහ වෙනත් අභිරුචි වින්‍යාස කිරීම් වැනි වෙබ් අඩවි ක්‍රියාකාරිත්වය නිවැරදිව සහතික කිරීමට අපි මූලික කුකීස් භාවිතා කරමු.",
    read_policy: "කුකී ප්‍රතිපත්තිය කියවන්න",
    support_title: "සහාය අමතන්න",
    support_subject_label: "විෂය",
    support_message_label: "පණිවිඩය",
    support_submit_button: "පණිවිඩයක් යවන්න",
    support_hint: "සටහන: මෙම පණිවිඩය යැවීමට ඔබගේ පෙරනිමි ඊමේල් යෙදුම විවෘත කරනු ඇත.",
    support_success_msg: "ඔබගේ ඊමේල් යෙදුම විවෘත කරමින්...",
    support_error_msg: "පණිවිඩ යැවීමට අසමත් විය. කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
    explorer_title: "ගවේෂක",
    history_title: "ඉතිහාසය",
    animation_title: "සජීවීකරණය",
    config_title: "මානකරනය",
    tool_mouse: "තෝරන්න (Ctrl+M)",
    tool_brush: "බුරුසුව (Ctrl+B)",
    tool_brush_mode: "ටොගල් ප්‍රකාරය (ඝන/පැහැදිලි)",
    tool_eraser: "මකනය (Ctrl+E)",
    tool_brush_size: "බුරුසු ප්‍රමාණය සකසන්න",
    tool_bucket: "පුරවන්න (Ctrl+F)",
    tool_eyedropper: "අයිඩ්රොපර්",
    tool_grid: "ජාලකය (Ctrl+Shift+B)",
    tool_rotate: "කරකවන්න (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "මාරු කරන්න (Ctrl+Shift+T)",
    label_width: "පළල",
    label_height: "උස",
    label_frames: "රාමු ගණන",
    label_animation: "සජීවිකරණ විලාසය",
    label_background_color: "පසුබිම් වර්ණය",
    label_interval: "අන්තරය",
    tool_anim_config: "සජීවිකරණ වින්‍යාසය",
    label_new_width: "නව පළල",
    label_new_height: "නව උස",
    label_apply: "අයදුම් කරන්න",
    label_colors: "වර්ණ",
    label_size: "ප්රමාණය",
    label_tolerance: "ඉවසීම",
    val_horizontal: "තිරස්",
    val_vertical: "සිරස් අතට",
    val_sequence: "අනුපිළිවෙල",
    val_bounce: "Bounce",
    val_random: "අහඹු",
    val_solid: "ඝනයි",
    val_clear: "පැහැදිලියි",
    action_add_sheet: "නව පත්රය",
    action_import: "ආනයනය කරන්න",
    action_export: "අපනයනය කරන්න",
    action_sort_projects: "වර්ග කරන්න",
    sort_date_old: "පැරණිතම පළමු",
    sort_date_new: "අලුත්ම මුලින්ම",
    sort_name_az: "නම (A-Z)",
    sort_name_za: "නම (Z-A)",
    action_new_sprite: "නව ස්ප්‍රයිට්",
    action_new_project: "නව ව්යාපෘතිය",
    modal_save_all_title: "සියලුම වෙනස්කම් සුරකින්න",
    modal_save_all_desc: "සුරැකීමට වත්කම් තෝරන්න:",
    modal_save_selected: "තෝරාගත් සුරකින්න",
    action_saved: "සුරකින ලදී",
    modal_create_sprite_title: "නව ස්ප්‍රයිට් සාදන්න",
    modal_create_project_title: "නව ව්‍යාපෘතියක් සාදන්න",
    modal_add_sheet_title: "නව පත්රය එකතු කරන්න",
    modal_rename_sheet_title: "පත්‍රය නැවත නම් කරන්න",
    modal_rename_sprite_title: "Sprite නැවත නම් කරන්න",
    modal_delete_sprite_title: "Sprite මකන්න",
    modal_delete_project_title: "ව්‍යාපෘතිය මකන්න",
    modal_delete_sheet_title: "පත්රය මකන්න",
    placeholder_sprite_name: "නම",
    placeholder_project_name: "නම",
    placeholder_sheet_name: "නම",
    placeholder_new_name: "නව නම",
    action_create: "නිර්මාණය කරන්න",
    action_add: "එකතු කරන්න",
    action_rename: "නැවත නම් කරන්න",
    action_duplicate: "අනුපිටපත් කරන්න",
    action_delete: "මකන්න",
    action_cancel: "අවලංගු කරන්න",
    confirm_delete_sprite: "ඔබට මෙම ස්ප්‍රයිට් මැකීමට අවශ්‍ය බව විශ්වාසද?",
    confirm_delete_project: "ඔබට මෙම ව්‍යාපෘතිය මැකීමට අවශ්‍ය බව විශ්වාසද? සියලුම ස්ප්රීතු ඉවත් කරනු ලැබේ.",
    confirm_delete_sheet: "ඔබට මෙම පත්‍රය මැකීමට අවශ්‍ය බව විශ්වාසද?",
    err_select_sprite: "කරුණාකර පළමුව ස්ප්‍රයිට් එකක් තෝරන්න.",
    err_select_project: "කරුණාකර පළමුව ව්‍යාපෘතියක් තෝරන්න.",
    err_name_empty: "නම හිස් විය නොහැක.",
    err_sprite_exists: "එම නම සහිත ස්ප්‍රයිට් එකක් දැනටමත් පවතී.",
    err_project_exists: "එම නම සහිත ව්‍යාපෘතියක් දැනටමත් පවතී.",
    err_no_content: "සුරැකීමට අන්තර්ගතයක් නැත.",
    err_no_changes: "සුරැකීමට වෙනස්කම් නොමැත.",
    err_delete_last_sheet: "අවසාන පත්‍රය මකා දැමිය නොහැක.",
    err_extract_frames: "කිසිදු රාමුවක් උපුටා ගැනීමට නොහැකි විය.",
    err_indexeddb: "දේශීයව සුරැකීමට අසමත් විය. ඔබගේ බ්‍රවුසරය IndexedDB සඳහා සහය නොදක්වයි.",
    msg_upload_success: "උඩුගත කිරීම සාර්ථකයි: {0}",
    msg_upload_failed: "උඩුගත කිරීම අසාර්ථක විය: {0}",
    msg_save_success: "සුරැකීම සාර්ථකයි.",
    msg_saving: "සුරකිමින්...",
    msg_multi_save_result: "වත්කම් {0}ක් සුරකින ලදී. {1} අසාර්ථක වීම්.",
    menu_title: "මෙනුව",
    menu_save: "සුරකින්න",
    menu_save_all: "සියල්ල සුරකින්න",
    menu_support: "සහාය අමතන්න",
    label_local_storage: "දේශීය ගබඩාව",
    label_sign_in: "පුරන්න",
    modal_export_title: "ස්ප්‍රයිට් අපනයනය කරන්න",
    label_filename: "ගොනු නාමය",
    label_format: "ආකෘතිය",
    action_export_confirm: "අපනයනය කරන්න",
};

export default translations;
